import styled from 'styled-components';
import THEME from '../../styles/colors';

const StyledSeparator = styled.div`
  border-left: 1px solid ${THEME.general.border};
  box-sizing: border-box;
  height: 32px;
  width: 1px;
  margin: 0 16px;
`;

export default StyledSeparator;
